import {TagCodeLibelleDto, GestionArticleDto, IGestionCatalogueWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class EnregistrementArticleResolver implements Resolve<GestionArticleDto> {

  constructor(private gestionCatalogueWebService: IGestionCatalogueWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.gestionCatalogueWebService.getArticle(id);
  }
}

@Injectable()
export class ReferentielAutorisationsResolver implements Resolve<TagCodeLibelleDto> {

  constructor(private gestionCatalogueWebService: IGestionCatalogueWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.gestionCatalogueWebService.getAutorisations();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/articles/enregistrement/enregistrement.articles.resolver.ts